<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-card tile flat>
      <v-layout py-5 wrap>
        <v-flex align-self-center text-center xs12>
          <span
            style="
              padding-left: 50px;
              font-family: poppinsbold;
              color: #e7ab5f;
              font-size: 38px;
              letter-spacing: 4px;
            "
          >
            SERVICES
          </span>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex
          py-5
          v-for="(item, i) in services"
          :key="i"
          xs10
          md12
          x12
          offset-md0
          offset-lg0
          offset-xs1
          lg12
        >
          <span v-if="i % 2 != 0">
            <v-layout wrap>
              <v-flex xs12 lg1> </v-flex>
              <v-flex xs12 lg6>
                <v-img height="450px" :src="baseURL + item.image">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#FF2323"
                      ></v-progress-circular>
                    </v-row> </template
                ></v-img>
              </v-flex>

              <v-flex xs12 lg4>
                <v-layout pl-3 pt-12 wrap>
                  <v-flex xs12 lg12>
                    <v-layout justify-center wrap>
                      <v-flex xs12 lg12>
                        <span
                          style="
                            font-family: poppinsbold;
                            font-size: 24px;
                            color: #00000;
                            letter-spacing: 1px;
                          "
                        >
                          {{ item.name }}
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex text-justify xs12 lg12>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #777777;
                            letter-spacing: 0px;
                          "
                        >
                          {{ item.text }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 lg1> </v-flex>
            </v-layout>
          </span>
          <span v-else>
            <v-layout wrap>
              <v-flex xs12 lg1> </v-flex>
              <v-flex xs12 lg4>
                <v-layout pr-3 pt-12 wrap>
                  <v-flex xs12 lg12>
                    <v-layout justify-center wrap>
                      <v-flex xs12 lg12>
                        <span
                          style="
                            font-family: poppinsbold;
                            font-size: 24px;
                            color: #00000;
                            letter-spacing: 1px;
                          "
                        >
                          {{ item.name }}
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex text-justify xs12 lg12>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #777777;
                            letter-spacing: 0px;
                          "
                        >
                          {{ item.text }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 lg6>
                <v-img height="450px" :src="baseURL + item.image">
                   <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#FF2323"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                </v-img>
              </v-flex>
              <v-flex xs12 lg1> </v-flex>
            </v-layout>
          </span>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      services: [],
      appLoading: false,
    };
  },
  mounted: function () {
    this.getServices();
  },
  methods: {
    getServices() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/service/providers/list",
      })
        .then((response) => {
          if (response.data.status) {
            var serviceData = {};
            serviceData = response.data.data;
            for (var i = 0; i < serviceData.length; i++) {
              if (serviceData[i].text) {
                this.services.push(serviceData[i]);
              }
            }
            this.appLoading = false;
          } else this.appLoading = false;
        })
        .catch(() => {
          this.appLoading = false;
        });
    },
  },
};
</script>